<template>
  <div class="wrapper" id="fillInfo">
    <div class="contentModule" >
      <div class="space-between theme">
        <div>
          <div class="insuranceTheme">泰康在线车险 - 订单详情</div>
          <div class="insuranceDescription"></div>
        </div>
      </div>
      <div class="section">
        <div class="customerIcon">
          <span class="icon"></span>
        </div>
        <div class="item">
          <span>订单状态：</span>
          <span class="orderStatusChinese"></span>
        </div>
        <div class="item">
          <span>订单号：</span>
          <span class="orderId"></span>
        </div>
        <el-collapse v-model="titleList">
          <!-- 险别信息 -->
          <el-collapse-item title="险别信息" name="1">
            <div class="insuranceTitle sectionTitle">
              <div class="vertical"></div>
              <div>商业险</div>
            </div>
            <div class="biList">
              <el-table
                class="tableTitle"
                border
                :data="commercialInsuranceDetailList"
                style="width: 100%">
                <el-table-column
                  prop="kindName"
                  label="险别"
                  min-width="49%">
                </el-table-column>
                <el-table-column
                  prop="label"
                  label="产品计划"
                  min-width="19%">
                </el-table-column>
                <el-table-column
                  prop="kindFlag"
                  label="不计免赔"
                  min-width="15%">
                </el-table-column>
                <el-table-column
                  prop="premium"
                  label="保费(元)"
                  min-width="15%">
                </el-table-column>
              </el-table>
            </div>
            <ul class="detailedList">
              <li class="biProtectionPeriod">
                <div class="">商业保期：</div>
                <div class="biPeriod"></div>
              </li>
              <li class="ciProtectionPeriod">
                <div>交强保期：</div>
                <div class="ciPeriod"></div>
              </li>
            </ul>
          </el-collapse-item>
          <!-- 车辆信息 -->
          <el-collapse-item title="车辆信息" name="2">
            <ul class="detailedList">
              <li>
                <div>车牌号码 ：</div>
                <div class="licenseNo"></div>
              </li>
              <li>
                <div>品牌型号 ：</div>
                <div class="vehicleBrand_vehicleModel"></div>
              </li>
              <li>
                <div>发动机号 ：</div>
                <div class="engineNo"></div>
              </li>
              <li>
                <div style="letter-spacing: 6px;">车架号</div>：
                <div class="frameNo"></div>
              </li>
              <li>
                <div>注册日期 ：</div>
                <div class="enrollDate"></div>
              </li>
              <li class="isChgOwnerFlag">
                <div style="letter-spacing: 6px;">过户车</div>：
                <div>是</div>
              </li>
              <li class="isChgOwnerFlag">
                <div>过户日期 ：</div>
                <div class="transferDate"></div>
              </li>
              <li>
                <div>燃料 (能源) 种类 ：</div>
                <div class="fuelType"></div>
              </li>
            </ul>
          </el-collapse-item>
          <!-- 人员信息 -->
          <el-collapse-item title="人员信息" name="3" class="fillInfo">
            <ul class="ownerInfo detailedList">
              <li>
                <div><span style="margin-right: 28px">车</span>主 ：</div>
                <div class="relationName"></div>
              </li>
              <li>
                <div style="letter-spacing: 6px;">手机号</div>：
                <div class="mobile"></div>
              </li>
              <li>
                <div><span style="margin-right: 28px">性</span>别 ：</div>
                <div class="sex"></div>
              </li>
              <li>
                <div>出生日期 ：</div>
                <div class="relationBrithday"></div>
              </li>
              <li>
                <div>证件类型 ：</div>
                <div class="idtype">身份证</div>
              </li>
              <li>
                <div>证件号码 ：</div>
                <div class="idnumber"></div>
              </li>
            </ul>

            <ul class="insureInfo detailedList">
              <li>
                <div style="letter-spacing: 6px;">投保人</div>：
                <div class="relationName"></div>
              </li>
              <li>
                <div style="letter-spacing: 6px;">手机号</div>：
                <div class="mobile"></div>
              </li>
              <li>
                <div><span style="margin-right: 28px">性</span>别 ：</div>
                <div class="sex"></div>
              </li>
              <li>
                <div>出生日期 ：</div>
                <div class="relationBrithday"></div>
              </li>
              <li>
                <div>证件类型 ：</div>
                <div class="idtype">身份证</div>
              </li>
              <li>
                <div>证件号码 ：</div>
                <div class="idnumber"></div>
              </li>
            </ul>

            <ul class="beInsureInfo detailedList">
              <li>
                <div>被投保人 ：</div>
                <div class="relationName"></div>
              </li>
              <li>
                <div style="letter-spacing: 6px;">手机号</div>：
                <div class="mobile"></div>
              </li>
              <li>
                <div><span style="margin-right: 28px">性</span>别 ：</div>
                <div class="sex"></div>
              </li>
              <li>
                <div>出生日期 ：</div>
                <div class="relationBrithday"></div>
              </li>
              <li>
                <div>证件类型 ：</div>
                <div class="idtype">身份证</div>
              </li>
              <li>
                <div>证件号码 ：</div>
                <div class="idnumber"></div>
              </li>
            </ul>

            <ul class="wallahInfo detailedList">
              <li>
                <div>业务经办人 ：</div>
                <div class="relationName"></div>
              </li>
              <li>
                <div>经办人类别 ：</div>
                <div class="relationName"></div>
              </li>
              <li>
                <div style="letter-spacing: 6px;">手机号</div>：
                <div class="mobile"></div>
              </li>
              <li>
                <div><span style="margin-right: 28px">性</span>别 ：</div>
                <div class="sex"></div>
              </li>
              <li>
                <div>出生日期 ：</div>
                <div class="relationBrithday"></div>
              </li>
              <li>
                <div>证件类型 ：</div>
                <div class="idtype">身份证</div>
              </li>
              <li>
                <div>证件号码 ：</div>
                <div class="idnumber"></div>
              </li>
            </ul>
          </el-collapse-item>
          <!-- 发票信息 -->
          <el-collapse-item title="发票信息" name="4" class="invoiceRetract">
            <ul class="invoiceInfo detailedList">
              <li>
                <div>纳税人类别 ：</div>
                <div class="taxpayerType"></div>
              </li>
              <li>
                <div>发票类别 ：</div>
                <div class="receiptType"></div>
              </li>
              <li class="special">
                <div><span style="margin-right: 28px">银</span>行 ：</div>
                <div class="bank"></div>
              </li>
              <li class="special">
                <div>银行账号 ：</div>
                <div class="account"></div>
              </li>
              <li class="special">
                <div>详细地址 ：</div>
                <div class="rAddress"></div>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <div class="total">
          <span>费用合计：</span>
          <span class="totalPremium"></span>
        </div>
        <div class="businessScore" v-show="businessScore">
          <span>保单综合评分：</span>
          <span class="businessScoreValue" v-html="businessScore"></span>
        </div>
        <div class="payContainer" v-show="payQrcode">
          <span>请使用微信扫码完成验车并支付：</span>
          <vue-qr ref="Qrcode" :text="payUrl" :size="120" :margin="10" class="payQrcode"></vue-qr>
        </div>
        <div class="step space-around">
          <button class="nextStep" id="immediateInsurance" @click="submitOrder()" data-value="1" onmouseover="this.style.backgroundColor='#ff8a73';" onmouseout="this.style.backgroundColor='#ff7052';" onmouseup="this.style.backgroundColor='#d95e45';">确认投保</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import vueQr from 'vue-qr';
  export default {
    name: "orderDetail",
    components:{
      vueQr
    },
    data() {
      return {
        shareToken: null,                   // 分享token
        beShareToken: null,                 // 被分享token
        quoteIdNum: null,                   // 报价订单ID
        eventLogToken: null,                // 事件日志Token
        orderToken: '',                     // 订单token
        productId: '100464',                // 产品ID

        titleList: [],
        commercialInsuranceDetailList: [{}],      // 商业险险种列表
        businessScore: null,              // 保单综合评分

        payQrcode: false,                    // 支付弹窗
        payUrl: '',                          // 支付url
      }
    },
    methods: {
      //-- 事件绑定
      eventBinding() {
        let that = this;

        //-- 找客服 二维码 绑定事件
        $(".customerIcon").on("click", function(){
          window.open('https://work.weixin.qq.com/kfid/kfce82ed2eaaae38c7f');
        });
      },
      // 报价详情
      getQuotation(){
        let that = this;
        that.axios.post('/management/quotecarinsurance/getQuotation',{
          quoteIdNum: that.quoteIdNum,
          beShareToken: that.beShareToken,
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            responseHandler(data['datas']);
          } else {
            that.$message.error(data.msg);
          }
        });

        function responseHandler(datas) {
          const {car, bi, ci, priceQuoteTime, orderToken, orderId, orderStatus, orderStatusChinese, relation, tax, sumPremium, businessScore} = datas;
          let timestamp = new Date().getTime();

          that.orderToken = orderToken;

          $('.orderId').html(orderId);
          $('.orderStatusChinese').html(orderStatusChinese);

          // 报价时间
          if (that.$$.isValidObj(priceQuoteTime)) $('.priceQuoteTime span').html(`*以上价格仅供参考(报价时间：${priceQuoteTime})，最终价格以出单为准，祝您生活愉快。`)

          // 车辆信息
          const {licenseNo, engineNo, frameNo, enrollDate, chgOwnerFlag, transferDate, fuelType, vehicleBrand, vehicleModel } = car;

          $('.licenseNo').html(licenseNo);
          $('.engineNo').html(engineNo);
          $('.frameNo').html(frameNo);
          $('.enrollDate').html(enrollDate);

          // 是否过户车
          if (chgOwnerFlag == '1') {
            $(".isChgOwnerFlag").css('display', 'inline-block');
            $(".transferDate").html(transferDate);
          }

          // 燃料 (能源) 种类
          let fuelTypeList = [{label: '燃油', value: '0'}, {label: '纯电动', value: '1'}, {label: '燃料电池', value: '2'}, {label: '插电式混合动力', value: '3'}, {label: '其他混合动力', value: '4'}, {label: '其他', value: '9'}];
          if (!that.$$.isValidObj(fuelType)) $('.fuelType').html('燃油');
          for (let i in fuelTypeList){
            const {label, value} = fuelTypeList[i];
            if (fuelType == value) $('.fuelType').html(label);
          }

          // 品牌型号
          $('.vehicleBrand_vehicleModel').html(`${vehicleBrand}${vehicleModel}`);


          // 商业险
          if (that.$$.isValidObj(bi) && that.$$.isValidMap(bi)){
            const {disCount, list, startTime, endTime} = bi;
            let amounts = '';

            if (!that.$$.isValidMap(list)) return;

            $('.biPeriod').html(`<span>${startTime}</span>
                  <span>至</span>
                  <span>${endTime}</span>`);
            $('.biProtectionPeriod').css('display', 'inline-block');

            for (let i in list){
              let {amount, kindName, deductibleRate, kindCode, premium, quantity, kindFlag, unitAmount} = list[i];

              if ('104,115,79,204'.includes(kindCode)){
                amounts = that.unitConversion(amount) + '元/座*' + quantity + '座';
              }else {
                amounts = that.unitConversion(amount);
              }

              // 增值服务险别
              if ('74,75,76,77,274,275,276,277'.includes(kindCode)) {
                amounts = `${quantity}次`;
              }

              // 附加绝对免赔率特约险
              if ('701,702,703,704,705'.includes(kindCode)) {
                amounts = `${(deductibleRate * 100)}%`;
              }

              // 商业险 - 险种列表
              that.commercialInsuranceDetailList[i] = {
                kindName,
                label: amounts,
                kindCode,
                quantity,
                kindFlag: that.$$.isValidObj(kindFlag) && kindFlag == '1' ? '√':'',
                premium: premium == '0' ? '0:00' : premium,
              };
            }

            // 险种起始时间小于当前时间，当前报价单不能转投保
            /*let startTimeTimestamp = new Date(startTime).getTime();
            if (startTimeTimestamp < timestamp) $('.immediateInsurance').hide();*/
          }

          // 交强险
          if (that.$$.isValidObj(ci) && that.$$.isValidMap(ci)){
            const {disCount, premium, startTime, endTime} = ci;

            $('.ciPeriod').html(`<span>${startTime}</span>
                  <span>至</span>
                  <span>${endTime}</span>`);
            $('.ciProtectionPeriod').css('display', 'inline-block');

            // 险种起始时间小于当前时间，当前报价单不能转投保
            /*let startTimeTimestamp = new Date(startTime).getTime();
            if (startTimeTimestamp < timestamp) $('.immediateInsurance').hide();*/
          }

          // 费用合计
          $('.totalPremium').html('￥' + sumPremium);

          // 保单综合评分
          that.businessScore = that.$$.isValidObj(businessScore) ? businessScore : null;

          // 订单状态
          if(that.$$.isValidObj(orderStatus)){
            switch (orderStatus) {
              case 0:
              case 1:
              case 8:{
                //-- 支付组件高度兼容
                const payContainerHeight = $(".total").outerHeight();

                $(".wrapper").css({"padding-bottom": `${payContainerHeight}px`});
                $(".total").show();
                break;
              }
              default:{
                $(".total").remove();
                break;
              }
            }
          }

          // 投保信息
          if (that.$$.isValidObj(relation)){
            let {carOwner, policyHolder, insuredUser, agent} = relation;
            // 车主信息
            ergodicLoading('ownerInfo', carOwner);

            // 投保人信息
            ergodicLoading('insureInfo', policyHolder);

            // 被投保人信息
            ergodicLoading('beInsureInfo', insuredUser);

            // 业务经办人信息
            if (policyHolder.idtype == '6') ergodicLoading('wallahInfo', agent);
          }

          // 发票信息
          if (that.$$.isValidObj(tax) && that.$$.isValidMap(tax)){
            $('.invoiceRetract, .invoiceInfo').show();

            let {taxpayerType, receiptType, bank, account, rAddress} = tax,
              taxpayerTypeList = {'0': '个人', '1': '一般纳税人', '1': '小规模纳税人'},
              receiptTypeList = {'2': '电子普票', '3': '增值税专用发票', '4': '纸质普票'};

            $(`.invoiceInfo .taxpayerType`).html(taxpayerTypeList[taxpayerType]);
            $(`.invoiceInfo .receiptType`).html(receiptTypeList[receiptType]);
            if (receiptType == '3'){
              $(`.special`).css('display', 'inline-block');
              $(`.invoiceInfo .bank`).html(bank);
              $(`.invoiceInfo .account`).html(account);
              $(`.invoiceInfo .rAddress`).html(rAddress);
            }
          }

          function ergodicLoading(infoName, data) {
            let {relationName, mobile, sex, relationBrithday, idtype, idnumber} = data,
              idtypeList = {'1': '身份证', '6': '统一社会信用代码'},
              sexList = {'M': '男', 'F': '女', 'O': '其他'};

            if (infoName == 'wallahInfo') $(`.${infoName}`).show();
            $(`.${infoName} .relationName`).html(relationName);
            $(`.${infoName} .idnumber`).html(idnumber);
            $(`.${infoName} .mobile`).html(mobile);
            $(`.${infoName} .sex`).html(sexList[sex]);
            $(`.${infoName} .idtype`).html(idtypeList[idtype]);
            $(`.${infoName} .relationBrithday`).html(relationBrithday);
          }

          that.titleList = ['1', '2', '3', '4'];
        }
      },
      // 确认投保
      submitOrder(){
        let that = this,
          url = '',
          { pathname, host } = window.location,
          {shareToken, beShareToken, quoteIdNum, eventLogToken} = that,
          clientDomainH5 = host.indexOf('xbyf.xiaobaibao.com') !== -1 ? 'https://mtadmin.xiaobaibao.com/src/pages/product/autoInsurance/orderDetail.html':'https://newtest.xiaobaibao.com/src/pages/product/autoInsurance/orderDetail.html';

        // 验车和支付需要分开两次请求，PC端无法同步，所以生成H5订单详情链接二维码，引导用户去H5完成验车和支付
        console.log(eventLogToken)
        let params = {quoteIdNum, eventLogToken, beShareToken: that.$$.isValidObj(beShareToken) ? beShareToken : shareToken },
          urlPars = that.$$.jsonToUrlParams(params);
        url = clientDomainH5 + urlPars;
        that.payUrl = url;
        that.payQrcode = true;
        console.log(url)

        // 验车/支付链接请求
        /*that.$$.request({
          url: that.UrlConfig.management_mobileInsuranceInfo_bindSellBillAtCostHandler,
          pars: {
            orderToken,
          },
          loading: true,
          sfn: function (data) {
            that.$$.closeLoading();

            const { success, msg, datas } = data;
            if (success) {
              let url = '',
                { payUrl } = datas;

              if(that.$$.isValidObj(payUrl)){
                url = payUrl;
              }else {
                if( window.location.host.indexOf(this.$$.constant.client) === -1 ){
                  url = this.$$.constant.h5TestClient + "/product/paymentDetail.html?orderToken=" + orderToken + "&beShareToken=" + beShareToken;
                }else {
                  url = this.$$.constant.h5Client + "/product/paymentDetail.html?orderToken=" + orderToken + "&beShareToken=" + beShareToken;
                }
              }
              that.payUrl = url;
              that.payQrcode = true;
            } else {
              that.$message.error(msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });*/

      },
      // 数值转化 - 万
      unitConversion(num) {
        if (num.toString().includes('.')) return num;
        num = Number(num);
        if (num < 10000) {
          return num + '';
        } else {
          return (num / 10000) + '万';
        }
      },
      //-- 获取分享token
      createShareToken() {
        let that = this;

        that.$$.request({
          url: that.UrlConfig.management_quotecarinsurance_createShareToken,
          method : 'GET',
          sfn: function (data) {

            const { success, msg, datas } = data;
            if (success) {
              const {shareToken, requestToken} = data['datas'];
              that.shareToken = shareToken;

              if (!that.$$.isValidObj(that.eventLogToken)) {
                let token = decodeURIComponent(encodeURIComponent(requestToken).replace(new RegExp("%20","gm"),"%2B"));
                that.eventLogToken = token;

                // 修改 - URL全部参数
                let { origin, pathname } = window.location,
                  {beShareToken, quoteIdNum} = that,
                  params = {quoteIdNum, eventLogToken: token};

                if (that.$$.isValidObj(beShareToken)) params[beShareToken] = beShareToken;
                let urlPars = that.$$.jsonToUrlParams(params),
                  url = origin + pathname + urlPars;
                history.pushState("", "", url);

                // 产品屏幕录制
                that.recording();
              }
            } else {
              that.$message.error(msg);
            }
          },
          ffn: function (data) {
            that.$$.errorHandler();
          }
        });
      },
      // 产品屏幕录制
      recording(){
        let that = this;
        let eventLogToken = decodeURIComponent(encodeURIComponent(that.eventLogToken).replace(new RegExp("%20","gm"),"%2B"));
        if (that.$$.isValidObj(eventLogToken)) {
          that.screenRecBase.startLoad();
          that.eventLogToken = eventLogToken;
        }
      },

    },
    mounted() {
      let that = this,
        quoteIdNum = that.$route.query.quoteIdNum,
        eventLogToken = that.$route.query.eventLogToken,
        beShareToken = that.$route.query.beShareToken;

      if (that.$$.isValidObj(beShareToken)) that.beShareToken = beShareToken;
      if (that.$$.isValidObj(quoteIdNum)) {
        let id = decodeURIComponent(encodeURIComponent(quoteIdNum.toString()).replace(new RegExp("%20","gm"),"%2B"));
        that.quoteIdNum = id;
        that.getQuotation();
      }

      if (that.$$.isValidObj(eventLogToken)) {
        that.eventLogToken = eventLogToken;

        // 产品屏幕录制
        that.recording();
      }

      // 事件绑定
      that.eventBinding();

      // 获取 - 分享token
      that.createShareToken();
    }
  }
</script>

<style scoped>
  @import "../../../../../static/css/dutyInsurance/fillInfo.css";

  .wrapper{
    overflow-x: auto;
  }

  .section{
    position: relative;
    min-width: 1000px;
    margin: 0 auto;
    background: #FFFFFF;
    box-shadow: 0 0 1rem 0 rgba(203, 203, 203, 0.2);
  }

  .customerIcon{
    width: 40px;
    height: 30px;
    background: #5677fc;
    display: inline-block;
    position: absolute;
    right: 0;
    border-radius: 20px 0 0 20px;
    top: -35px;
    z-index: 2;
  }
  .customerIcon .icon{
    background: url('../../../../../static/images/public/autoInsurance/customerIcon.png') no-repeat;
    width: 21px;
    height: 18px;
    display: inline-block;
    background-size: contain;
    margin-top: 6px;
    margin-left: 12px;
  }

  .item{
    padding: 10px 3%;
    color: #727272;
    font-size: 14px;
    border-bottom: 1px solid #f2f2f2;
  }

  .orderStatusChinese,
  .orderId{
    color: #ff7052;
  }

  /deep/ .el-collapse{
    border-top: none;
  }
  /deep/ .el-collapse-item__content{
    padding: 10px 3%;
  }

  /deep/ .el-collapse-item__header{
    color: #727272;
    font-weight: bold;
    font-size: 16px;
    padding: 0 3%;
    border-bottom: 1px solid #ffffff;
    background: #f2f2f2;
  }

  .sectionTitle{
    padding: 5px 10px;
    margin-bottom: 1px;
    background: #f2f2f2;
  }
  .sectionTitle div {
    display: inline-block;
    vertical-align: middle;
    -webkit-line-clamp: 1;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
  }

  .sectionTitle .vertical {
    width: 3px;
    height: 15px;
    background: #FF7052;
    border-radius: 3px;
  }

  .fillInfo ul{
    border-bottom: 1px solid #E5E5E5;
  }
  .detailedList>li{
    position: relative;
    width: 49%;
    line-height: 30px;
    padding: 10px 0;
    color: #606266;
    background-color: #fff;
    display: inline-block;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-user-select: none;
    -moz-user-select: none;
    font-size: 13px;
  }

  .detailedList li>div{
    display: inline-block;
    vertical-align: middle;
  }
  .detailedList li>div:nth-child(2){
    color: #ff7052;
  }

  .total{
    padding: 10px 3%;
    display: none;
  }

  .payContainer{
    padding: 10px 3%;
    margin-bottom: 20px;
  }

  .invoiceRetract,
  .invoiceInfo {
    display: none;
  }

  .detailedList .isChgOwnerFlag{
    display: none;
  }

  .totalPremium {
    color: #ff7052!important;
    font-size: 16px;
    font-weight: bold;
  }


  .biList /deep/ .el-table td,
  .biList /deep/ .el-table th{
    padding: 10px 0;
  }

  .payQrcode{
    vertical-align: middle;
    width: 150px;
    height: 150px;
  }

  .detailedList .biProtectionPeriod,
  .detailedList .ciProtectionPeriod {
    display: none;
  }

  .wallahInfo{
    display: none;
  }

  .detailedList .special{
    display: none;
  }

  .businessScore{
    width: 100% !important;
    margin-bottom: 20px;
    padding: 10px 3%;
    border-bottom: 1px solid #E5E5E5;
  }
  .businessScoreValue{
    color: #ff7052;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/autoInsurance/taikang/orderDetail.vue